import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { parseQueryStringLens } from './parse-query-string-lens';
export function useUrlQueryValue({
  lens
} = {}) {
  const location = useLocation();
  const result = useMemo(() => {
    const l = parseQueryStringLens.then(lens);
    return l.get(location.search);
  }, [lens, location.search]);
  return result;
}